import { createStore } from 'vuex';
import emailjs from '@emailjs/browser';

export default createStore({
  state: {
    showPreloader: false,
    isLoaded: false,
    showPopup: false,
    showTimetablePopup: false,
    showFormLoader: false,
    showResult: null
  },
  mutations: {
    changePreloaderState(state, payload) {
      state.showPreloader = payload;
    },
    changeFormLoader(state, payload) {
      state.showFormLoader = payload;
    },
    changeShowResult(state, payload) {
      state.showResult = payload;
    },
    changePopupState(state, payload) {
      state.showPopup = payload;
    },
    changeTimetablePopupState(state, payload) {
      state.showTimetablePopup = payload;
    },
    changeFormSended(state, payload) {
      state.isFormSended = payload;
    },
    changeLoadedState(state, payload) {
      state.isLoaded = payload;
    }
  },
  actions: {
    sendMail({ state, getters, commit }, payload) {
      commit('changeFormLoader', true);
      // let finalArray = [];
      // Object.keys(state.cartItems).forEach((item) => {
      //   const element = state.cartItems[item];
      //   if (element.state) {
      //     finalArray.push([element.itemName, element.price]);
      //   }
      // });
      // let totalSum = getters.getTotalSum;
      // let saleSum = getters.getSaleSum;
      // const offerObj = {
      //   companyName: payload.companyName,
      //   companyEmail: payload.companyEmail,
      //   offerObj: finalArray.toString(),
      //   totalSum: totalSum,
      //   saleSum: saleSum,
      //   partner: state.isPartner ? 'Yes' : 'No',
      //   additionalArea: state.additionalArea ? 'Yes' : 'No'
      // };
      emailjs
        .send(
          process.env.VUE_APP_SERVICE_ID,
          process.env.VUE_APP_TEMPLATE_ID,
          {
            companyEmail: payload.companyEmail,
            companyName: payload.companyName,
            isBarter: true
          },
          process.env.VUE_APP_USER_ID
        )
        .then(() => commit('changeShowResult', true))
        .catch(() => commit('changeShowResult', false));
    }
  },
  modules: {}
});
